import { Environment, getConfiguration } from "../../config";
import { ApiClient } from "./ApiClient";

export class UnAuthClient extends ApiClient {

    constructor(env?: Environment) {
        const config = getConfiguration(env);

        super({
            baseApiUrl: config.voyagerApiUrl,
            apiVersion: config.voyagerApiVersion,
            basePath: "",
        });

    }

    async appendHeaders(): Promise<HeadersInit> {
        return Promise.resolve({})
    }

}